/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Vehicle_No_GpsInputs */

const vi_fleet_vehicle_no_gps = /** @type {(inputs: Fleet_Vehicle_No_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa cấu hình GPS`)
};

/**

* @param {Fleet_Vehicle_No_GpsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_vehicle_no_gps = /** @type {((inputs?: Fleet_Vehicle_No_GpsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Vehicle_No_GpsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_vehicle_no_gps(inputs)
});